import {
  GENERATED_EMAIL_PATTERN,
  SOCIETY_PARTNER_GENERATED_EMAIL_PATTERN,
} from 'constants/defaultConstants';

export const isGeneratedEmail = (email: string): boolean => {
  if (!email || typeof email !== 'string') {
    return false;
  }

  return (
    GENERATED_EMAIL_PATTERN.test(email) ||
    SOCIETY_PARTNER_GENERATED_EMAIL_PATTERN.test(email)
  );
};
